import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LsqCommonModule } from '@lsq-frontend/common-ui';
import { CreditLimitMinValidator } from '../validators/credit-limit-min.validator';
import { DashboardValidators } from '../validators/dashboard-validators';
import { FactoringDashboardModule } from './factoring-dashboard/factoring-dashboard.module';
import { AddUserPermissionsModalComponent } from './settings/add-user/add-user-permissions-modal.component';
import { AddUserPersonalDetailsModalComponent } from './settings/add-user/add-user-personal-details-modal.component';
import { AdminClaimComponent } from './settings/permissions/admin-claims/admin-claims.component';
import { LsqClaimRowComponent } from './settings/permissions/claim-row/lsq-claim-row.component';
import { PermissionsModalComponent } from './settings/permissions/permissions-modal.component';
import { PermissionsComponent } from './settings/permissions/permissions.component';
import { AddBankAccountFormComponent } from './supply-chain/bank-accounts/add-bank-account-form.component';
import { AddIntlBankAccountFormComponent } from './supply-chain/bank-accounts/add-intl-bank-account-form.component';
import { AddBankAccountControllerComponent } from './supply-chain/bank-accounts/bank-account-form-controller.component';

@NgModule({
    imports: [CommonModule, LsqCommonModule.forRoot()],
    declarations: [
        AddBankAccountFormComponent,
        AddIntlBankAccountFormComponent,
        AddBankAccountControllerComponent,
        AddUserPersonalDetailsModalComponent,
        AddUserPermissionsModalComponent,
        PermissionsComponent,
        PermissionsModalComponent,
        AdminClaimComponent,
        LsqClaimRowComponent
    ],
    exports: [
        CommonModule,
        LsqCommonModule,
        AddBankAccountFormComponent,
        AddIntlBankAccountFormComponent,
        AddBankAccountControllerComponent,
        AddUserPersonalDetailsModalComponent,
        AddUserPermissionsModalComponent,
        PermissionsComponent,
        AdminClaimComponent,
        PermissionsModalComponent,
        FactoringDashboardModule,
        LsqClaimRowComponent
    ],
    providers: [CreditLimitMinValidator, DashboardValidators]
})
export class AppCommonModule {
    // Eager loading the the validators to hydrate static validation methods.
    constructor(private _dashboardValidators: DashboardValidators) {}
}
